import React from "react";

import { Card, Button } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import TicketHeaderSkeleton from "../TicketHeaderSkeleton";
import ArrowBackIos from "@material-ui/icons/ArrowBackIos";
import { useHistory } from "react-router-dom";

const useStyles = makeStyles(theme => ({
	ticketHeader: {
		display: "flex",
		alignItems: "center",
		backgroundColor: theme.palette.type === "dark" ? "#1E293B" : "#FFFFFF",
		flex: "none",
		borderBottom: `1px solid ${theme.palette.type === "dark" ? "rgba(255,255,255,0.06)" : "#E2E8F0"}`,
		height: 60,
		borderRadius: 0,
		boxShadow: "none",
	},
	backButton: {
		minWidth: 36,
		padding: "6px 8px",
		color: theme.palette.type === "dark" ? "#94A3B8" : "#64748B",
		borderRadius: 8,
		marginLeft: 4,
		"&:hover": {
			backgroundColor: theme.palette.type === "dark" ? "rgba(255,255,255,0.06)" : "#F1F5F9",
			color: "#35af9a",
		},
	},
}));

const TicketHeader = ({ loading, children }) => {
	const classes = useStyles();
	const history = useHistory();

	const handleBack = () => {
		history.push("/tickets");
	};

	return (
		<>
			{loading ? (
				<TicketHeaderSkeleton />
			) : (
				<Card square className={classes.ticketHeader}>
					<Button className={classes.backButton} onClick={handleBack}>
						<ArrowBackIos style={{ fontSize: 18 }} />
					</Button>
					{children}
				</Card>
			)}
		</>
	);
};

export default TicketHeader;
